import { NAME as APP_NAME } from 'constants';
import { ROUTES as USER_ROUTES } from 'domain/fuse/auth/users/constants';

export const NAME = `${APP_NAME}/SYSTEM_USERS`;

export const REDUCER_NAME = 'systemUsers';

export const FORM_NAME = 'UPDATE_USERS_INFO';

export const ROUTES = {
  ROOT: `${USER_ROUTES.ROOT}/:userId/update`,
};
